export interface ISocialMedia {
  homepage: string;
}

export interface ISupportedSocialsMedia {
  facebook: ISocialMedia;
  twitter: ISocialMedia & { handle: string };
  instagram: ISocialMedia;
  linkedIn: ISocialMedia;
  tiktok: ISocialMedia;
  pinterest: ISocialMedia;
  youtube?: ISocialMedia;
}

interface ISupportedLocales {
  fr: ISupportedSocialsMedia;
  de: ISupportedSocialsMedia;
}

export const socialsMedia: ISupportedLocales = {
  fr: {
    facebook: {
      homepage: 'https://www.facebook.com/lafourche.fr',
    },
    twitter: {
      homepage: 'https://x.com/lafourchebio',
      handle: '@lafourchebio',
    },
    instagram: { homepage: 'https://instagram.com/lafourchebio' },
    linkedIn: { homepage: 'https://www.linkedin.com/company/lafourche' },
    tiktok: { homepage: 'https://www.tiktok.com/@lafourchebio' },
    pinterest: { homepage: 'https://fr.pinterest.com/lafourchebio/' },
    youtube: { homepage: 'https://www.youtube.com/@lafourchebio' },
  },
  de: {
    facebook: { homepage: 'https://www.facebook.com/Ackerherz.de/' },
    twitter: {
      homepage: 'https://twitter.com/ackerherz',
      handle: '@ackerherz',
    },
    instagram: { homepage: 'https://www.instagram.com/ackerherz.de/' },
    linkedIn: { homepage: 'https://www.linkedin.com/company/ackerherz/about/' },
    tiktok: { homepage: 'https://vm.tiktok.com/ZMNXVhvJ1/' },
    pinterest: { homepage: 'https://pin.it/3cp5c7V' },
  },
};

export const socialsMedia_DEFAULT = socialsMedia.fr;
